import { logger } from 'common-ui';
import { useUserStore } from '../../stores/userStore';
import { selectUserDetails } from '../../stores/userStore';
import { createNewCart } from './createNewCart';
import type { AuthDetails } from 'tsconfig/types';
import { getAnonymousToken } from '../../helpers/auth/getAnonymousToken';
import { refreshAuthToken } from '../../helpers/auth/refreshAuthToken';
import { reloadAuthToken } from '../../helpers/auth/reloadAuthToken';

export async function handleNewCartId(authAtomState: AuthDetails | null): Promise<void> {
  try {
    const userDetails = selectUserDetails(useUserStore.getState());
    const { loginType } = userDetails || {};

    if (loginType === 'unidentified') {
      await getAnonymousToken();
    } else {
      if (!authAtomState?.publicCsrf) {
        await reloadAuthToken();
      }
      await refreshAuthToken();
    }

    await createNewCart();
  } catch (error) {
    logger.error('Error handling new cart ID:', error);
    throw error; // Ensure the error is thrown to be caught by the caller
  }
}
